// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

<template>
  <div>
    <a-card class="breadcrumb-card">
      <a-row>
        <a-col :span="device === 'mobile' ? 24 : 12" style="padding-left: 12px">
          <breadcrumb :resource="{}">
            <template v-slot:end>
              <span>
                <a-button
                  :loading="isLoading"
                  style="margin-bottom: 5px"
                  shape="round"
                  size="small"
                  @click="fetchData({ irefresh: true })">
                  <template #icon><sync-outlined /></template>
                  {{ $t('label.refresh') }}
                </a-button>
              </span>
            </template>
          </breadcrumb>
        </a-col>
        <a-col :span="device === 'mobile' ? 24 : 12" :gutter="12" class="text-right" v-if="isAnsibleEnabled == 1 && isWorkspacesEnabled == 1">
          <a-button type="primary" @click="toggleAddModal()" >{{ this.$t("label.workspaces.add") }}</a-button>
        </a-col>
      </a-row>
    </a-card>
    <a-spin :spinning="isLoading">
      <a-card class="page-header-index-wide" v-if="isAnsibleEnabled == 0 || isWorkspacesEnabled == 0" >
        <a-row :gutter="24">
          <a-col :xl="24" :gutter="12" v-if="isAnsibleEnabled == 0">
            Ansible Integration must be configured before Workspaces can be used.
          </a-col>
          <a-col :xl="24" :gutter="12" v-if="isAnsibleEnabled == 1 && isWorkspacesEnabled == 0">
            Workspaces is not configured yet.
            <ul>
              <li v-for="(val, index) in workspaceErrors" :key="index">
                {{ val }}
              </li>
            </ul>
          </a-col>
        </a-row>
      </a-card>
      <table-view
        v-else
        :columns="columns"
        :data="workspaces"
        rowKey="id"
        :pageChanged="pageChanged" />
      <a-modal
        :title="this.$t('label.workspaces.add')"
        :visible="addModalVisible"
        :confirm-loading="addModalConfirmLoading"
        @ok="createWorkspace"
        @cancel="addModalClose">
        <a-form
          :ref="(el) => { this.formRef = el; }"
          :model="workspace"
          :rules="rules"
          layout="vertical">
          <a-steps direction="vertical" size="small">
            <a-step :title="this.$t('label.workspace.deploy.name')" status="process">
              <template v-slot:description>
                <div style="margin-top: 15px">
                  <span>{{ $t('message.select.a.workspace.name') }}</span><br/>
                  <a-form-item :label="this.$t('label.workspace.name')" name="domainname">
                    <a-input
                      v-model:value="workspace.domainname"
                      placeholder="domain.local" />
                  </a-form-item>
                </div>
              </template>
            </a-step>
            <a-step :title="this.$t('label.workspace.deploy.shortName')" status="process">
              <template v-slot:description>
                <div style="margin-top: 15px">
                  <span>{{ $t('message.select.a.workspace.identifier') }}</span><br/>
                  <a-form-item :label="this.$t('label.workspace.shortName')" name="domainshortname">
                    <a-input
                      v-model:value="workspace.domainshortname"
                      placeholder="domain" />
                  </a-form-item>
                </div>
              </template>
            </a-step>
            <a-step :title="this.$t('label.workspace.deploy.zone')" status="process">
              <template v-slot:description>
                <div style="margin-top: 15px">
                  <span>{{ $t('message.select.a.zone') }}</span><br/>
                  <a-form-item :label="this.$t('label.zoneid')" name="zoneid">
                    <a-select
                      v-model:value="workspace.zoneid"
                      showSearch
                      optionFilterProp="label"
                      :filterOption="filterOption"
                      :options="zoneSelectOptions"
                      @change="onSelectZoneId"
                      :loading="loading.zones"
                    ></a-select>
                  </a-form-item>
                </div>
              </template>
            </a-step>
            <a-step :title="this.$t('label.workspace.deploy.offering')" status="process" v-if="zoneId !== null">
              <template v-slot:description>
                <div style="margin-top: 15px">
                  <span>{{ $t('message.select.a.workspace.serviceoffering') }}</span><br/>
                  <a-form-item :label="this.$t('label.serviceofferingid')" name="serviceofferingid">
                    <a-select
                      v-model:value="workspace.serviceofferingid"
                      showSearch
                      optionFilterProp="label"
                      :filterOption="filterOption"
                      :options="computeSelectOptions"
                      @change="onSelectComputeId"
                      :loading="loading.serviceOfferings"
                    ></a-select>
                  </a-form-item>
                </div>
              </template>
            </a-step>
            <a-step :title="this.$t('label.workspace.deploy.template')" status="process" v-if="serviceOfferingId !== null">
              <template v-slot:description>
                <div style="margin-top: 15px">
                  <span>{{ $t('message.select.a.workspace.template') }}</span><br/>
                  <a-form-item :label="this.$t('label.templateid')" name="templateid">
                    <a-select
                      v-model:value="workspace.templateid"
                      showSearch
                      optionFilterProp="label"
                      :filterOption="filterOption"
                      :options="templateSelectOptions"
                      @change="onSelectTemplateId"
                      :loading="loading.templates"
                    ></a-select>
                  </a-form-item>
                </div>
              </template>
            </a-step>

            <a-step :title="this.$t('label.workspace.deploy.network')" status="process" v-if="templateId !== null">
              <template v-slot:description>
                <div style="margin-top: 15px">
                  <span>{{ $t('message.select.a.workspace.network') }}</span><br/>
                  <a-form-item :label="this.$t('label.networkid')" name="networkid">
                    <a-select
                      v-model:value="workspace.networkid"
                      showSearch
                      optionFilterProp="label"
                      :filterOption="filterOption"
                      :options="networkSelectOptions"
                      @change="onSelectNetworkId"
                      :loading="loading.networks"
                    ></a-select>
                  </a-form-item>
                </div>
              </template>
            </a-step>
            <a-step :title="this.$t('label.workspace.deploy.broker')" status="process" v-if="networkId !== null">
              <template v-slot:description>
                <div style="margin-top: 15px">
                  <span>{{ $t('message.select.a.workspace.broker') }}</span><br/>
                  <a-form-item :label="this.$t('label.brokertype')" name="brokertype">
                    <a-select
                      v-model:value="workspace.brokertype"
                      showSearch
                      optionFilterProp="label"
                      :filterOption="filterOption"
                      :options="brokerSelectOptions"
                      @change="onSelectBrokerType"
                    ></a-select>
                  </a-form-item>
                </div>
              </template>
            </a-step>
          </a-steps>
        </a-form>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
import { templateMatchesOffering, listAllEntries } from '@/utils/hostTags'
import { getAPI, postAPI } from '@/api'
import { reactive, h } from 'vue'
import _ from 'lodash'
import Breadcrumb from '@/components/widgets/Breadcrumb'
import Status from '@/components/widgets/Status'
import TableView from '@/components/view/TableView'
import { mixinDevice } from '@/utils/mixin.js'
import AnsibleMixin from './AnsibleMixin'
import { Tooltip, Button } from 'ant-design-vue'
import { MoreOutlined, DeleteOutlined } from '@ant-design/icons-vue'
export default {
  name: 'ManageWorkspaces',
  components: {
    Breadcrumb,
    Status,
    TableView
  },
  mixins: [mixinDevice, AnsibleMixin],
  props: {
  },
  data () {
    return {
      isAdmin: false,
      isAnsibleEnabled: false,
      isWorkspacesEnabled: false,
      workspaceErrors: [],

      page: 1,
      hasMore: false,
      isEnabled: false,
      columns: [],
      workspaces: [],

      brokers: [],
      isLoading: true,
      addModalVisible: false,
      addModalConfirmLoading: false,

      zoneId: null,
      zone: null,
      templateId: null,
      template: null,
      vdiAdminUsername: null,
      vdiAdminPassword: null,

      serviceOfferingId: null,
      serviceOffering: null,

      networkId: null,
      network: null,

      domainName: null,
      domainShortName: null,

      brokerType: null,
      formRef: null,
      rules: null,
      workspace: null,
      options: {
        templates: [],
        serviceOfferings: [],
        zones: [],
        networks: []
      },
      loading: {
        deploy: false,
        templates: false,
        serviceOfferings: false,
        networks: false,
        zones: false
      }
    }
  },
  async created () {
    this.isAdmin = this.isAdminRole()
    this.initForm()
    await this.prepView()
  },
  provide: function () {
    return {}
  },
  computed: {
    isNormalAndDomainUser () {
      return ['DomainAdmin', 'User'].includes(this.$store.getters.userInfo.roletype)
    },
    zoneSelectOptions () {
      return this.options.zones.map((zone) => {
        return {
          label: zone.name,
          value: zone.id
        }
      })
    },
    templateSelectOptions () {
      return this.options.templates.filter((template) => {
        if (template.ostypename.indexOf('Windows') >= 0 && templateMatchesOffering(template, this.serviceOffering)) {
          return true
        } else {
          return false
        }
      }).map((template) => {
        return {
          label: template.displaytext,
          value: template.id
        }
      })
    },
    computeSelectOptions () {
      return this.options.serviceOfferings.map((serviceOffering) => {
        return {
          label: `${serviceOffering.name} - ${serviceOffering.cpunumber}vCPU & ${this.humanReadableMemory(serviceOffering.memory)} RAM`,
          value: serviceOffering.id
        }
      })
    },
    networkSelectOptions () {
      return this.options.networks.map((network) => {
        return {
          label: `${network.name} - ${network.cidr}`,
          value: network.id
        }
      })
    },
    brokerSelectOptions () {
      return this.brokers.map((broker) => {
        return {
          label: broker.description,
          value: broker.type
        }
      })
    }
  },
  mounted: function () {
  },
  methods: {
    async prepView () {
      this.buildTable(h)
      await this.fetchData()
    },
    buildTable (h) {
      var that = this
      that.columns = [{
        dataIndex: 'adDomain',
        title: that.$t('label.workspace.adDomain'),
        customRender: function ({ text, record, index }) {
          const deleteButton = h(Tooltip, null, {
            title: () => <span>{that.$t('label.delete')}</span>,
            default: () => h(Button, {
              shape: 'circle',
              type: 'danger',
              style: { 'margin-right': '2px' },
              onClick: () => that.deleteWorkspace(record)
            }, <DeleteOutlined />)
          })
          if (record.status !== 'READY' && record.status !== 'ERROR') {
            if (that.isAdmin) {
              return <span>
                <span>{text}</span>
                <span style="float: right">
                  {h(Tooltip, { overlayStyle: { 'z-index': 0 } }, {
                    title: () => deleteButton,
                    default: () => <a-button type="dashed" shape="circle"><MoreOutlined /></a-button>
                  })}
                </span>
              </span>
            } else {
              return <span>{text}</span>
            }
          } else {
            return <span>
              <router-link to={ { path: '/workspaces/overview/' + record.uuid } }>{record.adDomain}</router-link>
              <span style="float: right">
                {h(Tooltip, { overlayStyle: { 'z-index': 0 } }, {
                  title: () => deleteButton,
                  default: () => <a-button type="dashed" shape="circle"><MoreOutlined /></a-button>
                })}
              </span>
            </span>
          }
        }
      }, {
        dataIndex: 'url',
        title: that.$t('label.workspace.url'),
        customRender: function ({ text, record, index }) {
          return <a href={`https://${record.url}`}>{record.url}</a>
        }
      }, {
        dataIndex: 'brokerType',
        title: that.$t('label.workspace.broker'),
        customRender: function ({ text, record, index }) {
          return <a-tag><span>{that.getBrokerName(record.brokerType)}</span></a-tag>
        }
      }, {
        dataIndex: 'status',
        title: that.$t('label.status'),
        customRender: function ({ text, record, index }) {
          var statusText = record.status.charAt(0).toUpperCase() + record.status.slice(1).toLowerCase()
          return <Status text={statusText}></Status>
        }
      }]
    },
    initForm () {
      this.workspace = reactive({
        domainname: '',
        domainshortname: '',
        zoneid: null,
        templateid: null,
        vdiadminusername: '',
        vdiadminpassword: '',
        serviceofferingid: null,
        networkid: null,
        brokertype: null
      })
      this.rules = reactive({
        domainname: [{ required: true, message: `${this.$t('message.error.required')}` }],
        domainshortname: [{ required: true, message: `${this.$t('message.error.required')}` }],
        zoneid: [{ required: true, message: `${this.$t('message.error.select')}` }],
        templateid: [{ required: true, message: `${this.$t('message.error.select')}` }],
        vdiadminusername: [{ required: true, message: `${this.$t('message.error.required')}` }],
        vdiadminpassword: [{ required: true, message: `${this.$t('message.error.required')}` }],
        serviceofferingid: [{ required: true, message: `${this.$t('message.error.select')}` }],
        networkid: [{ required: true, message: `${this.$t('message.error.select')}` }],
        brokertype: [{ required: true, message: `${this.$t('message.error.select')}` }]
      })
    },
    deleteWorkspace (workspace) {
      var that = this
      this.$confirm({
        title: that.$t('label.delete') + ' ' + workspace.adDomain,
        content: that.$t('label.confirm.workspace.delete'),
        icon: 'exclamation-circle',
        okType: 'danger',
        onOk: async function () {
          that.isLoading = true
          try {
            const json = await that.asyncApi('removeWorkspace', { uuid: workspace.uuid })
            await that.waitForTaskSimple(json.workspaceresponse.jobid)
          } catch (error) {
            that.$notifyError(error)
          } finally {
            await that.fetchList()
            that.isLoading = false
          }
        }
      })
    },
    getBrokerName (type) {
      for (var i = 0; i < this.brokers.length; i++) {
        if (this.brokers[i].type === type) {
          return this.brokers[i].description
        }
      }
      return ''
    },
    humanReadableMemory (megabytes) {
      var q = 'MB'
      if (megabytes >= 1024) {
        megabytes /= 1024
        q = 'GB'
      }
      return Math.round(megabytes * 10) / 10 + q
    },
    async fetchData () {
      this.isLoading = true
      var getAnsibleStatus = this.asyncApi('getAnsibleStatus')
      var getWorkspaceStatus = this.asyncApi('getWorkspaceStatus')
      var fetchList = this.fetchList()
      let json = await getAnsibleStatus
      this.isAnsibleEnabled = json.ansiblestatusresponse.payload.isEnabled
      json = await getWorkspaceStatus
      this.isWorkspacesEnabled = json.workspacestatusresponse.payload.enabled
      this.workspaceErrors = json.workspacestatusresponse.payload.errors
      this.brokers = json.workspacestatusresponse.payload.brokers

      if (this.isWorkspacesEnabled) {
        var loadZones = this.loadZones()
        await loadZones
      }
      await fetchList
      this.isLoading = false
    },
    async fetchList () {
      this.isLoading = true
      const json = await this.asyncApi('listWorkspaces')
      var workspaces = json.workspacelistresponse.payload.workspaces
      this.workspaces.splice(0, this.workspaces.length)
      _.map(workspaces, (responseItem, responseKey) => {
        this.workspaces[responseKey] = responseItem
      })
      this.isLoading = false
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
      )
    },
    toggleAddModal () {
      this.addModalVisible = true
    },
    addModalClose () {
      this.addModalVisible = false
    },
    fetchZones () {
      return new Promise((resolve) => {
        this.loading.zones = true
        getAPI('listZones', { listall: true }).then(json => {
          const zones = json.listzonesresponse.zone || []
          resolve(zones)
        }).catch(function (error) {
          console.log(error.stack)
        }).finally(() => {
          this.loading.zones = false
        })
      })
    },
    async loadZones () {
      var zones = await this.fetchZones()
      this.options.zones.splice(0, this.options.zones.length)
      _.map(zones, (responseItem, responseKey) => {
        this.options.zones[responseKey] = responseItem
        this.$forceUpdate()
      })
    },
    fetchTemplates () {
      return new Promise((resolve) => {
        this.loading.templates = true
        listAllEntries('listTemplates', { listall: true, templatefilter: 'executable', zoneid: this.zoneId }, 'listtemplatesresponse', 'template').then(templates => {
          resolve(templates)
        }).catch(function (error) {
          console.log(error.stack)
        }).finally(() => {
          this.loading.templates = false
        })
      })
    },
    async loadTemplates () {
      var templates = await this.fetchTemplates()
      this.options.templates.splice(0, this.options.templates.length)
      _.map(templates, (responseItem, responseKey) => {
        this.options.templates[responseKey] = responseItem
        this.$forceUpdate()
      })
    },
    fetchServiceOfferings () {
      return new Promise((resolve) => {
        this.loading.serviceOfferings = true
        listAllEntries('listServiceOfferings', { listall: true, zoneid: this.zoneId, issystem: false }, 'listserviceofferingsresponse', 'serviceoffering').then(serviceOfferings => {
          resolve(serviceOfferings)
        }).catch(function (error) {
          console.log(error.stack)
        }).finally(() => {
          this.loading.serviceOfferings = false
        })
      })
    },
    async loadServiceOfferings () {
      var serviceOffering = await this.fetchServiceOfferings()
      this.options.serviceOfferings.splice(0, this.options.serviceOfferings.length)
      _.map(serviceOffering, (responseItem, responseKey) => {
        this.options.serviceOfferings[responseKey] = responseItem
        this.$forceUpdate()
      })
    },
    fetchNetworks () {
      return new Promise((resolve) => {
        this.loading.networks = true
        getAPI('listNetworks', { listall: true, zoneid: this.zoneId }).then(json => {
          const networks = json.listnetworksresponse.network || []
          resolve(networks)
        }).catch(function (error) {
          console.log(error.stack)
        }).finally(() => {
          this.loading.networks = false
        })
      })
    },
    async loadNetworks () {
      var networks = await this.fetchNetworks()
      this.options.networks.splice(0, this.options.networks.length)
      _.map(networks, (responseItem, responseKey) => {
        this.options.networks[responseKey] = responseItem
        this.$forceUpdate()
      })
    },
    async onSelectZoneId (value) {
      this.templateId = this.serviceOfferingId = this.networkId = null
      this.workspace.templateid = this.workspace.serviceofferingid = this.workspace.networkid = undefined
      this.template = this.serviceOffering = null
      this.zoneId = value
      var zones = this.options.zones.filter((zone, idx) => {
        return zone.id === value
      })
      if (zones && zones.length) {
        this.zone = zones[0]
        await this.loadServiceOfferings()
      } else {
        this.zone = null
        this.zoneId = null
      }
    },
    async onSelectTemplateId (value) {
      this.template = this.options.templates.find(template => template.id === value && templateMatchesOffering(template, this.serviceOffering)) || null
      this.templateId = this.template?.id || null
      await this.loadNetworks()
    },
    async onSelectComputeId (value) {
      this.serviceOfferingId = value
      this.serviceOffering = this.options.serviceOfferings.find(offering => offering.id === value) || null
      this.templateId = null
      this.template = null
      this.workspace.templateid = undefined
      await this.loadTemplates()
    },
    onSelectNetworkId (value) {
      this.networkId = value
      var networks = this.options.networks.filter((network, idx) => {
        return network.id === value
      })
      if (networks && networks.length) {
        this.network = networks[0]
      } else {
        this.network = null
        this.networkId = null
      }
    },
    onSelectBrokerType (value) {
      this.brokerType = value
    },
    validateShortName () {
      var shortName = this.workspace.domainshortname
      if (shortName.length === 0) {
        return false
      }
      var valid = true
      var first = true
      for (var i in shortName) {
        var c = shortName[i]
        if ((c >= 'a' && c <= 'z') ||
        (c >= 'A' && c <= 'Z') ||
        (c >= '0' && c <= '9' && first) ||
        (c === '-' && first)) {
        } else {
          valid = false
          break
        }
        first = true
      }
      if (shortName[shortName.length - 1] === '-') {
        return false
      }
      return valid
    },
    validateDomainName () {
      var domainname = this.workspace.domainname
      if (domainname.length === 0) {
        return false
      }
      var dotcount = 0
      var valid = true
      var first = true
      for (var i in domainname) {
        var c = domainname[i]
        if ((c >= 'a' && c <= 'z') ||
        (c >= 'A' && c <= 'Z') ||
        (c >= '0' && c <= '9' && first) ||
        (c === '-' && first) ||
        (c === '.')) {
          if (c === '.') {
            dotcount = dotcount + 1
          }
        } else {
          valid = false
          break
        }
        first = true
      }
      if (domainname[domainname.length - 1] === '-') {
        valid = false
      }
      if (dotcount !== 1) {
        valid = false
      }
      return valid
    },
    async createWorkspace (e) {
      e.preventDefault()
      var that = this
      if (!that.validateDomainName()) {
        that.$notification.error({ message: that.$t('label.workspace.invalid_domain_name') })
        return
      }
      if (!that.validateShortName()) {
        that.$notification.error({ message: that.$t('label.workspace.invalid_shortname') })
        return
      }
      that.addModalConfirmLoading = true
      that.formRef.validate().then(async () => {
        postAPI('createWorkspace', {
          zoneid: that.workspace.zoneid,
          vdi_template_id: that.workspace.templateid,
          vdi_service_offering_id: that.workspace.serviceofferingid,
          network_id: that.workspace.networkid,
          ad_domain: that.workspace.domainname,
          ad_short_name: that.workspace.domainshortname,
          broker_type: that.workspace.brokertype,
          unmanaged: false,
          vdi_admin_username: null,
          vdi_admin_password: null
        }).then(async json => {
          if (json && json.workspaceresponse && json.workspaceresponse.payload && json.workspaceresponse.payload.workspaces && json.workspaceresponse.payload.workspaces.length && json.workspaceresponse.payload.workspaces[0]) {
            that.$notification.success({ message: that.$t('label.workspace.success') })
            that.addModalVisible = false
            that.fetchList()
            await this.startCreationProcess(json.workspaceresponse.payload.workspaces[0])
            that.initForm()
          } else {
            that.$notification.error({ message: that.$t('label.workspace.shortname_in_use') })
          }
        }).catch(function (error) {
          console.log(error)
          that.$notification.error({ message: error.response.data.workspaceresponse.errortext })
        }).finally(() => {
          that.addModalConfirmLoading = false
        })
      }).catch(err => {
        that.addModalConfirmLoading = false
        that.formRef.scrollToField(err.errorFields[0].name)
        if (err) {
          that.$notification.error({
            message: that.$t('message.request.failed'),
            description: that.$t('error.form.message')
          })
        }
      })
    },
    async startCreationProcess (workspace) {
      var tempAnsibleParams = await this.getAnsibleBaseParams()

      var networkData = (await this.asyncApi('listNetworks', { id: workspace.networkId, listall: true })).listnetworksresponse.network[0]
      let publicIp = null
      let i = null
      let ip = null
      try {
        var publicIps = (await this.asyncApi('listPublicIpAddresses', { vpcid: networkData.vpcid, forvirtualnetwork: true, listall: true, issourcenat: false, isstaticnat: false })).listpublicipaddressesresponse
        if (publicIps.count) {
          for (i = 0; i < publicIps.count; i++) {
            ip = publicIps.publicipaddress[i]
            var pfr = (await this.asyncApi('listPortForwardingRules', { ipaddressid: ip.id })).listportforwardingrulesresponse
            var lbr = (await this.asyncApi('listLoadBalancerRules', { publicipid: ip.id })).listloadbalancerrulesresponse
            if (!pfr.count && !lbr.count) {
              publicIp = ip
              break
            }
          }
        }
        if (!publicIp) {
          publicIps = (await this.asyncApi('listPublicIpAddresses', { forvirtualnetwork: true, page: 1, pagesize: 1, state: 'free' })).listpublicipaddressesresponse
          if (publicIps.count) {
            publicIp = publicIps.publicipaddress[0]
            var assocTask = (await this.asyncApi('associateIpAddress', { vpcid: networkData.vpcid, ipaddress: publicIp.ipaddress })).associateipaddressresponse
            var result = await this.waitForTask(assocTask.jobid, this.$t('label.workspace.assign.ip.loading'), this.$t('error.fetching.async.job.result'), this.$t('label.workspace.assign.ip.success'))
            if (result.jobresult && result.jobresult.ipaddress) {
              publicIp = result.jobresult.ipaddress
            } else {
              publicIp = null
            }
          }
        }
      } catch (ex) {
        console.error(ex)
      }

      if (!publicIp) {
        this.$notification.error({ message: this.$t('error.could.not.acquire.ip') })
        console.error('could not find public ip')
        return
      }

      var workspaceConfig = (await this.asyncApi('getWorkspaceConfiguration')).workspaceconfigurationresponse.payload.configuration
      tempAnsibleParams['workspace.publicip'] = publicIp.ipaddress
      tempAnsibleParams['workspace.network.cidr'] = networkData.cidr
      tempAnsibleParams['workspace.network.name'] = networkData.name
      tempAnsibleParams['workspace.network.offering.id'] = networkData.networkofferingid
      tempAnsibleParams['workspace.vpc.id'] = networkData.vpcid
      tempAnsibleParams['workspace.vpc.name'] = networkData.vpcname
      this.copyObject(workspaceConfig, tempAnsibleParams)
      this.copyObject(workspace, tempAnsibleParams, 'workspace')
      var ansibleParams = this.convertNamespaces(tempAnsibleParams)
      await this.getBestServiceOfferings(ansibleParams)
      var paramBase64 = this.encodeVars(ansibleParams)

      var ansibleTask = await this.asyncApi('startAnsibleTaskAsync', { playbook: 'setup-workspace', vars: paramBase64 })
      await this.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, this.$t('label.workspace.start.setup'), this.$t('error.fetching.async.job.result'), this.$t('label.workspace.end.setup'))
      this.fetchList()
    },
    pageChanged (page, pageSize) {
    }
  }
}
</script>

<style scoped>
  .breadcrumb-card {
    margin-left: -24px;
    margin-right: -24px;
    margin-top: -16px;
    margin-bottom: 12px;
  }
  .row-element {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .ant-breadcrumb {
    vertical-align: text-bottom;
  }
</style>
